import { types } from 'mobx-state-tree';
import moment from 'moment';

const CatalogItemsParams = types
  .model('CatalogItemsParams', {
    text: '',
    priceFrom: types.optional(types.union(types.string, types.number), ''),
    priceTo: types.optional(types.union(types.string, types.number), ''),
    deliveryTimeFrom: types.optional(types.union(types.string, types.number), ''),
    deliveryTimeTo: types.optional(types.union(types.string, types.number), ''),
    categories: types.optional(types.array(types.string), []),
    availableItemsForListing: types.optional(types.boolean, false),
    conditions: types.optional(types.array(types.string), []),
  })
  .views(self => ({
    get deliveryTimeFromFormatted() {
      return self.deliveryTimeFrom ? moment.unix(self.deliveryTimeFrom).format('YYYY-MM-DD') : '';
    },
    get deliveryTimeToFormatted() {
      return self.deliveryTimeTo ? moment.unix(self.deliveryTimeTo).format('YYYY-MM-DD') : '';
    },
    get anyFilter() {
      return (
        self.text ||
        self.priceFrom !== '' ||
        self.priceTo !== '' ||
        self.deliveryTimeFrom !== '' ||
        self.deliveryTimeTo !== '' ||
        self.categories.length ||
        self.conditions.length ||
        self.availableItemsForListing !== false
      );
    },
    get deliveryTimeOrCategoriesChanged() {
      return (
        !self.text &&
        self.priceFrom === '' &&
        self.priceTo === '' &&
        (self.deliveryTimeFrom !== '' ||
          self.deliveryTimeTo !== '' ||
          self.categories.length ||
          self.conditions.length)
      );
    },
  }))
  .actions(self => ({
    setCategories(t) {
      self.categories = t;
    },
    setConditions(t) {
      self.conditions = t;
    },
    setDeliveryTimeFrom(t) {
      self.deliveryTimeFrom = parseInt(t, 10) || '';
    },
    setAvailableItemsForListing(t) {
      self.availableItemsForListing = t;
    },
    setDeliveryTimeTo(t) {
      self.deliveryTimeTo = parseInt(t, 10) || '';
    },
    setText(t) {
      self.text = t;
    },
    setPriceFrom(v) {
      const t = v.replaceAll(',', '.');
      self.priceFrom = t === `${parseFloat(t)}` ? parseFloat(t) : t;
    },
    setPriceTo(v) {
      const t = v.replaceAll(',', '.');
      self.priceTo = t === `${parseFloat(t)}` ? parseFloat(t) : t;
    },
    resetValues() {
      self.text = '';
      self.priceFrom = '';
      self.priceTo = '';
      self.deliveryTimeFrom = '';
      self.deliveryTimeTo = '';
      self.categories = [];
      self.conditions = [];
      self.availableItemsForListing = false;
    },
  }));

export default CatalogItemsParams;
